<!-- eslint-disable -->
<template>
  <CommonPages id="category-list"
    :class="['category-list',deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']"
    :titlePrefix="categoryTitle">
    <!-- 顶部标题区域 -->
    <div class="categories-container">
      <div class="categories-header" :class="[deviceType]">
        <div class="categories-title">{{ categoryTitle }}</div>
        <div class="categories-subtitle">{{ categoryDescription }}</div>
      </div>

      <!-- <AdComponent :key="'ads-category-list-1'"
        v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_list_1"
        ref="ads-category-list-1" class="ad-width-100 pc_padding m_padding"
        :ads="adsensConfig?.categories_list_1" :showDebug="showDebug" /> -->
    </div>

    <div class="similar-name-section" :class="[deviceType]">
      <!-- 结果标题区域 -->
      <div class="results-header" :class="[deviceType]">
        <!-- PC版布局 -->
        <template v-if="deviceType !== 'mobile'">
          <div class="results-dot"></div>
          <div class="results-title">Your Results</div>
          <div class="sort-container">
            <span class="sort-label">Sort By:</span>
            <el-select v-model="sortBy" class="sort-select" popper-class="sort-dropdown">
              <el-option v-for="item in sortOptions" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </div>
        </template>
        <!-- 移动端布局 -->
        <template v-else>
          <div class="results-header-top">
            <div class="results-dot"></div>
            <div class="results-title">Your Results</div>
          </div>
          <div class="sort-container">
            <span class="sort-label">Sort By:</span>
            <el-select v-model="sortBy" class="sort-select" popper-class="sort-dropdown">
              <el-option v-for="item in sortOptions" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </div>
        </template>
      </div>

      <!-- 名字列表区域 -->
      <div class="similar-names-list" :class="[deviceType]">
        <template v-for="(card, index) in nameCards">
          <router-link :key="index" :to="`/names/${card.name.toLowerCase()}/${card.id}`" tag="div"
            class="name-card-link">
            <div class="name-card" :style="{ background: card.background }">
              <div class="card-header">
                <div class="card-info">
                  <div class="card-name">{{ card.name }}</div>
                  <div class="card-pronunciation">{{ card.pronunciation }}</div>
                </div>
                <div class="card-gender-icon">
                  <img :src="card.genderIcon" alt="gender icon" />
                </div>
              </div>
              <div class="card-details">
                <div class="detail-row">
                  <span class="detail-label">US Popularity</span>
                  <span class="detail-value">{{ card.popularity }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">Style</span>
                  <span class="detail-value">{{ card.style }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">Meaning</span>
                  <span class="detail-value text-ellipsis">
                    {{ card.meaningList.join(', ') }}
                  </span>
                </div>
              </div>
            </div>
          </router-link>
          <!-- Mobile ad after 2nd card -->
          <AdComponent v-if="deviceType === 'mobile' && index === 0" :key="'ads-category-list-1'"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_list_1"
            ref="ads-category-list-1" class="ad-width-100 " :ads="adsensConfig?.categories_list_1"
            :showDebug="showDebug" />

          <!-- Mobile ad after 5th card -->
          <AdComponent v-if="deviceType === 'mobile' && index === 2" :key="'ads-category-list-2'"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_list_2"
            ref="ads-category-list-2" class="ad-width-100 " :ads="adsensConfig?.categories_list_2"
            :showDebug="showDebug" />

          <!-- PC ad after 8th card -->
          <AdComponent v-if="deviceType !== 'mobile' && index === 3" :key="'ads-category-list-1'"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_list_1"
            ref="ads-category-list-1" class="ad-width-100  ad-grid-full-width"
            :ads="adsensConfig?.categories_list_1" :showDebug="showDebug" />
        </template>
      </div>
    </div>

    <!-- <AdComponent v-if="deviceType != 'mobile' " :key="'ads-category-list-3'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_list_3"
      ref="ads-category-list-3" class="ad-width-100 pc_padding"
      :ads="adsensConfig?.categories_list_3" :showDebug="showDebug" /> -->

    <!-- 组合模块 -->
    <div class="combinations-section" :class="[deviceType]" v-if="combinations.length > 0">
      <div class="section-header">
        <div class="section-title">Combinations</div>
      </div>
      <div class="combinations-container">
        <div class="combination-row" :class="[deviceType]">
          <div class="combination-card-link" v-for="(combo, index) in combinations" :key="index"
            @click="navigateTo(combo.url)" @mouseenter="hoveredCombination = index"
            @mouseleave="hoveredCombination = null">
            <div class="combination-card" :class="{'hovered': hoveredCombination === index}">
              <div class="combination-text">
                {{ combo.title }}
              </div>
              <div class="see-more-button">
                <span>See More</span>
                <img src="@/assets/default/arrow-right-small_w.svg" alt="arrow"
                  class="arrow-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <AdComponent v-if="deviceType === 'mobile' && nameCards < 4" :key="'ads-category-list-3'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.categories_list_3"
      ref="ads-category-list-3" class="ad-width-100 m_padding"
      :ads="adsensConfig?.categories_list_3" :showDebug="showDebug" /> -->

    <section class="search-sec-row" :class="[deviceType]">
      <!-- 搜索过滤区域 -->
      <div class="section-header" :class="[deviceType]">
        <div class="section-title">Search by Filter</div>
      </div>

      <div class="names-filter" :class="[deviceType]">
        <SearchFilter />
      </div>
    </section>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import SearchFilter from '@/components/SearchFilter.vue';
import AdComponent from '@/pages/components/AdComponent.vue'
import '@/css/common.scss';

export default {
  name: 'CategoryList',
  components: {
    CommonPages,
    SearchFilter,
    AdComponent,
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      hoveredCard: null,
      hoveredCombination: null,
      nameCards: [],
      combinations: [],
      sortBy: 'S_3',
      sortOptions: [
        { value: 'S_1', label: 'A-Z' },
        { value: 'S_2', label: 'Z-A' },
        { value: 'S_3', label: 'Most Popular' },
        { value: 'S_4', label: 'Most Unique' }
      ],
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig',
      "adsensConfig",
      'adPosConfig',
      'showDebug',
    ]),
    // 获取路由参数
    categoryParams () {
      return {
        cate: this.$route.params.cate || 'gender',
        value: this.$route.params.value || 'boy',
      };
    },
    categoryTitle () {
      const { value } = this.categoryParams;
      return `Browse ${this.capitalize(value)} Names`;
    },
    categoryDescription () {
      const { value } = this.categoryParams;
      return `From timeless classics to hidden gems, our ${this.capitalize(value)} name list brings together inspiration, meaning, and beauty for your naming journey.`;
    },
    pageTitle () {
      const { value } = this.categoryParams;
      return `Browse ${this.capitalize(value)} Names`;
    },
    pageDescription () {
      const { value } = this.categoryParams;
      return `From timeless classics to hidden gems, our ${this.capitalize(value)} name list brings together inspiration, meaning, and beauty for your naming journey.`;
    }
  },
  methods: {
    async fetchNames () {
      const { cate, value } = this.categoryParams;
      const params = {
        origin: this.domainConfig?.origin || '',
        pageSize: 20,
        pageNum: 1,
        sortType: this.sortBy,
      };

      if (cate === 'gender' || cate === 'meaning' || cate === 'letter') {
        params[cate] = [this.capitalize(value)];
      } else if (cate === 'style' || cate === 'syllables') {
        params[cate] = this.capitalize(value);
      }

      try {
        const response = await this.$global.server.postAPI({
          method: 'post',
          params,
          url: '/name/page',
        });
        if (response.data && response.data.list) {
          this.nameCards = response.data.list.map(item => {
            let background = '';
            const GENDER_COLORS = {
              Boy: 'linear-gradient(180deg, #0088FF 0%, rgba(0, 136, 255, 0.2) 100%)',
              Girl: 'linear-gradient(180deg, #E54CBA 0%, rgba(229, 76, 186, 0.2) 100%)',
              Unisex: 'linear-gradient(180deg, #C8AD17 0%, rgba(200, 173, 23, 0.2) 100%)',
            };
            background = GENDER_COLORS[item.gender] || GENDER_COLORS.Unisex;

            return {
              id: item.id || '',
              name: item.name || '',
              gender: item.gender,
              genderIcon: item.gender === 'Boy'
                ? require('@/assets/icons/male.svg')
                : item.gender === 'Unisex'
                  ? require('@/assets/icons/unsex.svg')
                  : require('@/assets/icons/female.svg'),
              pronunciation: item.pronunciation || '',
              style: item.style || '',
              meaningList: item.meaningList || [],
              popularity: item.popularity || '',
              background: background
            }
          });
        } else {
          this.nameCards = [];
        }
      } catch (error) {
        console.error('Error fetching names:', error);
        this.nameCards = [];
      }
    },
    async fetchCombinations () {
      const origin = this.domainConfig?.origin || '';
      try {
        const params = { origin };
        const response = await this.$global.server.postAPI({
          method: 'get',
          params,
          url: '/name/combinations',
        });
        if (response.data && response.data.combinations) {
          this.combinations = response.data.combinations.slice(0, 4);
        }
      } catch (error) {
        console.error('Error fetching combinations:', error);
        this.combinations = [];
      }
    },
    navigateTo (url) {
      if (url) {
        this.$router.push(url);
      }
    },
    // 首字母大写
    capitalize (str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  watch: {
    sortBy () {
      this.fetchNames();
    },
    '$route.params': {
      handler () {
        this.fetchNames();
      },
      deep: true,
    },
  },
  beforeMount () {
    this.fetchNames();
    this.fetchCombinations();
  },
  async mounted () {
    await this.initAdSystem();
    // 确保在广告系统初始化后再初始化跟踪
    this.$nextTick(() => {
      this.initAdTracking();
    });
  },
};
</script>


<style lang="scss" >
@import '~@/css/variables.scss';
.el-select-dropdown__list {
	padding: rem(3) 0;
}
.el-select-dropdown__item {
	padding: 0 rem(3) !important;
}
.el-select-dropdown__item.selected {
	color: #000;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
	background: rgba(0, 0, 0, 0.1);
}
.el-form {
	padding-bottom: 0;
}
.el-input__inner {
	border-radius: rem(20);
	border: rem(2) solid rgba(0, 0, 0, 0.1);
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
	border-color: #fff;
}
.el-input__inner:hover {
	border-color: rgba(0, 0, 0, 0.3);
}
.el-select:hover .el-input__inner {
	border-color: rgba(0, 0, 0, 0.3);
}
.el-select .el-input__inner:focus {
	border-color: #fff;
}
.el-select__caret {
	color: #fff !important;
}
.sort-select {
	width: rem(140);
	.el-input__inner {
		border: none;
		color: #fff;
		padding: 0 !important;
		font-size: rem(16);
		font-style: normal;
		font-weight: 700;
		line-height: rem(16); /* 100% */
		text-transform: capitalize;
	}
}
.el-select__tags {
	max-width: calc(100% - rem(30));
}
.el-tag {
	background-color: rgba(0, 0, 0, 0.1);
	border-color: rgba(0, 0, 0, 0.2);
	color: #fff;
}
.el-tag .el-tag__close {
	color: #fff;
}
.el-tag .el-tag__close:hover {
	background-color: #fff;
	color: #fff;
}

.detect_deviece_mobile {
	.el-select-dropdown__item {
		font-size: rem(13);
		line-height: rem(34);
		height: rem(34);
	}
	.el-input__inner {
		height: rem(60);
		padding: rem(18) rem(44) rem(18) rem(24);
		border-radius: rem(20);
		border: rem(2) solid rgba(0, 0, 0, 0.1);
		background: #fff;
		color: #03133a;
		font-size: rem(18);
		font-style: normal;
		font-weight: 700;
		line-height: rem(20); /* 111.111% */
		text-transform: capitalize;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: inline-block;
	}
	.el-input__suffix {
		right: rem(24);
	}
	.el-select__caret {
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
	}
	.sort-select {
		.el-input__inner {
			border: none !important;
			border-radius: 0;
			color: #fff;
			font-size: rem(16);
			font-style: normal;
			font-weight: 700;
			height: rem(16); /* 100% */
			line-height: rem(16); /* 100% */
			text-transform: capitalize;
		}
		.el-input__suffix {
			right: rem(8);
		}
		.el-select__caret {
			font-size: rem(16);
		}
	}
}
</style>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.category-list {
	background-color: #000;

	.categories-container {
		background: linear-gradient(180deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 1) 100%), linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
		width: 100%;
		padding-bottom: rem(52);
	}

	.categories-header {
		padding: rem(52) rem(180);
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: flex-start;
		justify-content: center;

		.categories-title {
			color: #fff;
			font-size: rem(52);
			font-weight: 900;
			line-height: rem(60);
		}

		.categories-subtitle {
			color: #fff;
			font-size: rem(20);
			line-height: rem(28);
			max-width: rem(800);
		}
	}

	.similar-name-section {
		padding: rem(40) rem(180) 0;
	}

	.results-header {
		display: flex;
		align-items: center;
		margin-bottom: rem(24);

		.results-dot {
			width: rem(8);
			height: rem(8);
			background-color: #fff;
			border-radius: 50%;
			margin-right: rem(12);
		}

		.results-title {
			color: #fff;
			font-size: rem(24);
			font-weight: 900;
			margin-right: auto;
		}

		.sort-container {
			display: flex;
			align-items: center;
			gap: rem(8);

			.sort-label {
				color: #fff;
				font-size: rem(14);
			}

			:deep(.sort-select) {
				.el-input__inner {
					color: #fff;
					font-weight: 700;
				}

				.el-select__caret {
					color: #fff !important;
				}
			}
		}
	}

	.similar-names-list {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: rem(24);

		.name-card-link {
			text-decoration: none;
		}

		.name-card {
			border-radius: rem(16);
			padding: rem(16);
			display: flex;
			flex-direction: column;
			gap: rem(16);
			color: #fff;
			cursor: pointer;
			transition: transform 0.3s ease;

			&:hover {
				transform: translateY(rem(-4));
			}

			.card-header {
				display: flex;
				justify-content: space-between;
				align-items: flex-start;

				.card-info {
					.card-name {
						font-size: rem(20);
						font-weight: 900;
					}

					.card-pronunciation {
						font-size: rem(12);
						font-style: italic;
					}
				}

				.card-gender-icon {
					width: rem(24);
					height: rem(24);
					background: #fff;
					border-radius: rem(8);
					display: flex;
					align-items: center;
					justify-content: center;

					img {
						width: rem(16);
						height: rem(16);
					}
				}
			}

			.card-details {
				display: flex;
				flex-direction: column;
				gap: rem(8);

				.detail-row {
					background: rgba(255, 255, 255, 0.1);
					border-radius: rem(8);
					padding: rem(8) rem(12);
					display: flex;
					justify-content: space-between;
					align-items: center;

					.detail-label {
						font-size: rem(12);
						opacity: 0.8;
					}

					.detail-value {
						font-size: rem(13);
						font-weight: 700;
					}

					.text-ellipsis {
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						max-width: rem(120);
					}
				}
			}
		}
	}

	.combinations-section {
		padding: rem(80) rem(180);

		.section-header {
			margin-bottom: rem(24);

			.section-title {
				color: #fff;
				font-size: rem(24);
				font-weight: 900;
			}
		}

		.combinations-container .combination-row {
			display: grid;
			grid-template-columns: repeat(4, 1fr);
			gap: rem(24);
		}

		.combination-card-link {
			text-decoration: none;
			padding: rem(2);
			border-radius: rem(16);
			background: transparent;
			transition: all 0.3s ease;
			&:hover {
				background: linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%);
			}
		}

		.combination-card {
			background: rgb(26, 26, 26);
			border-radius: rem(14);
			padding: rem(24);
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			height: rem(172);
			box-sizing: border-box;
			cursor: pointer;

			.combination-text {
				color: #fff;
				font-size: rem(18);
				font-weight: 700;
			}

			.see-more-button {
				background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
				border-radius: rem(8);
				padding: rem(8) rem(16);
				display: flex;
				align-items: center;
				justify-content: center;
				gap: rem(8);
				width: rem(100);

				span {
					color: #fff;
					font-size: rem(12);
					font-weight: 700;
				}

				.arrow-icon {
					width: rem(6);
					height: rem(10);
					filter: brightness(0) invert(1);
				}
			}
		}
	}

	.search-sec-row {
		padding: 0 rem(180) rem(80);

		.section-header {
			margin-bottom: rem(24);

			.section-title {
				color: #fff;
				font-size: rem(24);
				font-weight: 900;
			}
		}
	}

	&.detect_deviece_mobile {
		.categories-header {
			padding: rem(32) rem(16);

			.categories-title {
				font-size: rem(52);
				line-height: rem(60);
				margin-bottom: rem(16);
				text-align: left;
			}

			.categories-subtitle {
				font-size: rem(16);
				line-height: rem(24);
				text-align: left;
			}
		}

		.similar-name-section {
			padding: rem(32) rem(16) 0;
		}

		.results-header {
			flex-direction: column;
			align-items: flex-start;
			gap: rem(16);

			.results-header-top {
				display: flex;
				align-items: center;
			}

			.sort-container {
				width: 100%;
				justify-content: space-between;
			}
		}

		.similar-names-list {
			grid-template-columns: 1fr;
			gap: rem(16);
		}

		.combinations-section {
			padding: rem(40) rem(16);
			.combinations-container .combination-row {
				display: flex;
				overflow-x: auto;
				gap: rem(16);
				padding: 0 rem(16);
				margin: 0 rem(-16);
				&::-webkit-scrollbar {
					display: none;
				}
				-ms-overflow-style: none;
				scrollbar-width: none;
			}
			.combination-card-link {
				flex-shrink: 0;
				width: rem(280);
			}
		}

		.search-sec-row {
			padding: 0 rem(16) rem(40);
		}
		.categories-cards .category-card .card-footer {
			width: 100%;
			border-radius: rem(12);
			padding: rem(16);

			.view-all {
				font-size: rem(14);
				font-style: normal;
				font-weight: 700;
				line-height: rem(14); /* 100% */
				text-transform: capitalize;
			}
		}
	}
}
</style> 